import { BaseObject, IBaseObjectArgs } from "../../../core/business-objects/base-object/base-object.model";

export interface IBillingPackageArgs extends IBaseObjectArgs {
    title?: string;
    monthlyCost?: number;
    jobCost?: number;
    annualCost?: number;
    userLimit?: number;
}

const defaults = {
    title: "",
    monthlyCost: 0,
    jobCost: 0,
    annualCost: 0,
    userLimit: 0
} as IBillingPackageArgs;

export class BillingPackage extends BaseObject {
    title: string;
    monthlyCost: number;
    jobCost: number;
    annualCost: number;
    userLimit: number;

    constructor(data?: IBillingPackageArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/billing-package/billing-package.model.ts